import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { useState } from 'react';
import { Button, Alert} from '@mui/material';
import useAxiosPrivate from '../../hooks/use-axios-private';
import { alertMsg } from '../../utils/basicUtils';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import ErrorIcon from '@mui/icons-material/Error';
import Popup from '../../components/Popup';
import { useTheme } from '@emotion/react';

const ImportUserList = ({ user, rejectedRows }) => {
    return (
        <>
            <React.Fragment>
                <TableRow sx={{ height: { xs: 65, xl: 70 }, backgroundColor: rejectedRows && "#ff63470f" }}>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, height: "24px" }}>
                        {rejectedRows &&
                            <ErrorIcon sx={{ color: "#ff5a5a", pt: 0.8 }} />
                        }
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, }}>
                        <Box sx={{ ml: 2 }}>
                            <Typography sx={{ fontSize: "15px", }}>{user.first_name ? user.first_name : "--"}</Typography>
                        </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, }}>{user.last_name ? user.last_name : "--"}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, }}>{user.username ? user.username : "--"}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, }}>{user.email ? user.email : "--"}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, }}>{user.password ? user.password : "--"}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, }}>{user.mobile_number ? user.mobile_code + user.mobile_number : "--"}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, }}>{user.street ? user.street : "--"}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, }}>{user.city ? user.city : "--"}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, }}>{user.state ? user.state : "--"}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, }}>{user.country ? user.country : "--"}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, }}>{user.zipcode ? user.zipcode : "--"}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, }}>{user.employee_id ? user.employee_id : "--"}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 2, }}>{user.role_id ? user.role_id : "--"}</TableCell>

                </TableRow>
            </React.Fragment>
        </>

    )
}


const headCells = [
    'First Name', 'Last Name', 'User Name', 'Email', 'Password', 'Mobile Number', 'Street', 'City', 'State', 'Country', 'postCode', 'Employee Id', 'Role Id'
];

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    <Typography component={"div"}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const BulkImportUsers = () => {
    const axios = useAxiosPrivate()
    const theme = useTheme()
    const [importUser, setImportUser] = useState([])
    const [rejectedRows, setRejectedRows] = useState(false)
    const [popupModel, setPopupModel] = useState(false)

    const handleFileChange = async (e) => {
        let formData = new FormData();
        formData.append("users", e.target.files[0]);
        try {
            let resp = await axios.post('users/bulk_import/', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            })
            alertMsg(resp.data.message, 'success')
            setImportUser(resp.data.data.users)
            e.target.value = null;

        }
        catch (error) {
            console.error(error)
        }
    }
    const createUser = async () => {
        try {
            let resp = await axios.post('users/bulk_create/', { users: importUser })
            alertMsg(resp.data.message, 'success')
            setRejectedRows(resp.data.data.rejected_rows)
        }
        catch (error) {
            console.error(error)
        }
    }
    return (
        <Box sx={{ width: '100%', }}>
            <Paper sx={{ width: '100%', mb: 2, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)", }}>
                <Box>
                    <Typography
                        sx={{ flex: '1 1 100%', fontSize: { xs: 18, xl: 20 }, fontWeight: 500, p: '25px' }}
                        id="tableTitle"
                        component="div"
                    >
                        {rejectedRows ? "Bulk create users" : "Bulk import users"}
                    </Typography>
                    {rejectedRows &&
                        <Alert severity={importUser.length === rejectedRows.length ? "error" : (rejectedRows.length > 0 ? "warning" : "success")}
                            sx={{ maxWidth: '50%', mx: "auto", display: "flex", justifyContent: "center" }} >
                            {importUser.length === rejectedRows.length ?
                                'Users creation failed'
                                :
                                (rejectedRows.length > 0
                                    ?
                                    `Out of ${importUser.length} users ${importUser.length - rejectedRows.length} users created.`
                                    :
                                    'Users created successfully'
                                )}

                        </Alert>
                    }
                    <input
                        type="file"
                        onChange={handleFileChange}
                        accept=".xlsx"
                        style={{ display: 'none' }}
                        id="image-upload"
                        
                    />
                    {importUser.length <= 0 &&
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 6, px: 3, height: "100%", }}>
                            <label htmlFor="image-upload">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    startIcon={<CloudUploadOutlinedIcon />}
                                >
                                    Select File
                                </Button>

                            </label >
                        </Box>
                    }
                    <Box sx={{ pb: 4, display: "flex", alignItems: "center", justifyContent: "space-between", px: 3, flexWrap: "wrap" }}>
                        <Box>
                            {rejectedRows &&
                                <Box>
                                    <label htmlFor="image-upload1">
                                        <Button
                                            variant="outlined"
                                            component="span"
                                        >
                                            Import again
                                        </Button>
                                    </label>
                                </Box>
                            }
                            {importUser.length > 0 && !rejectedRows &&
                                <Box>
                                    <Button
                                        variant="outlined"
                                        onClick={() => setPopupModel(true)}
                                    >
                                        Clear import user
                                    </Button>
                                </Box>
                            }
                        </Box>
                        <Box>
                            {importUser.length > 0 && !rejectedRows &&
                                <Box>
                                    <Button
                                        variant='outlined'
                                        onClick={() => {
                                            createUser()
                                        }}
                                    >
                                        Create User
                                    </Button>
                                </Box>
                            }
                        </Box>
                    </Box>

                    <input
                        type="file"
                        onChange={handleFileChange}
                        accept=".xlsx"
                        style={{ display: 'none' }}
                        id="image-upload1"
                        onClick={() => {
                            setImportUser([])
                            setRejectedRows(false)
                        }}
                    />
                    {importUser.length > 0
                        &&
                        <TableContainer>
                            <Table
                                sx={{ minWidth: 750, mb: 2 }}
                                aria-labelledby="tableTitle"
                                size={'small'}
                            >

                                <TableHead>
                                    <TableRow sx={{ height: { xs: 65, lg: 70 } }}>
                                        <TableCell></TableCell>
                                        {headCells.map((headCell) => (
                                            <TableCell
                                                key={headCell}
                                                align="center"
                                                sx={{ whiteSpace: "nowrap", px: 3 }}
                                            >
                                                {headCell}
                                            </TableCell>
                                        ))}

                                    </TableRow>
                                </TableHead>

                                <TableBody>

                                    {importUser.map((user, index) => {
                                        return (
                                            <ImportUserList
                                                key={index}
                                                rejectedRows={rejectedRows && rejectedRows.includes(index)}
                                                user={user}
                                            />
                                        )
                                    })}

                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                </Box>
            </Paper >
            <Box >
                <Popup show={popupModel} onSecondaryClick={() => setPopupModel(false)} title={'Clear import user?'} consent={false} variant='primary' primaryBtnTxt={"Yes"} secondaryBtnTxt={"No"}
                    onPrimaryClick={() => {
                        setPopupModel(false)
                        setImportUser([])
                        setRejectedRows(false)
                    }}
                >
                    <Box sx={{ mt: 2, textAlign: "center" }}>
                        <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> Are you sure you want to clear all this user </Typography>
                    </Box>
                </Popup>
            </Box>
        </Box >
    );

}

export default BulkImportUsers